// Import JavaScript components
// import './components/accordion';
// import './components/tabs';
// import './components/toggle';

//If you want cookie consent
// import "./modules/cookie-consent";

//If you need a class to be toggled on a different element
// import "./modules/toggle";

//If you need to do something when its in/out of the viewport
// import "./modules/intersects";

import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, Grid } from "swiper";
Swiper.use([Navigation, Pagination, Autoplay, Grid]);

// carousels
new Swiper("#card-carousel", {
  slidesPerView: 1,
  spaceBetween: 16,
  pagination: {
    el: ".card-carousel-pagination",
    clickable: true,
  },
  breakpoints: {
    1200: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
  },
});

// Code to force above carousel to show 2 slides per view if there are only 2 in the carousel

var carouselcards = document.getElementById("card-carousel");

if (carouselcards) {
  console.log("works");
  var slidecount = carouselcards.firstElementChild.childElementCount;
  const slides = Array.from(carouselcards.firstElementChild.children);

  if (slidecount == 2) {
    slides.forEach((slide) => {
      slide.classList.add("lg:!w-[49%]");
    });
  }
}

// Hero Carousel

new Swiper("#hero-carousel", {
  slidesPerView: 1,
  autoplay: true,
  speed: 1000,
  pagination: {
    el: ".hero-carousel-pagination",
    clickable: true,
  },
});

document.getElementById("hamburgerToggle").onclick = () => {
  document.getElementById("hamburger").classList.toggle("is-active");
  document.getElementById("mainmenu").classList.toggle("main-menu-active");
};

document.getElementById("mobileHamburgerToggle").onclick = () => {
  document.getElementById("mobileHamburger").classList.toggle("is-active");
  document.getElementById("mobilemenu").classList.toggle("mobile-menu-active");
};

window.addEventListener("DOMContentLoaded", (event) => {
  const sitebody = document.getElementById("site-content");

  if (sitebody.firstElementChild.classList.contains("hero-slider")) {
    document.getElementById("site-header").classList.add("bg-transparent");
    document.getElementById("site-header").classList.add("text-white");
    sitebody.firstElementChild.classList.add("hero-margin");
  } else {
    document.getElementById("site-header").classList.add("bg-white");
  }
});

var headerlinkwidth = document.getElementById("headerlinks").offsetWidth;

document.getElementById("headerMenu").style.width = headerlinkwidth + "px";
